import { useEffect } from 'react';

/**
 * The iBoon AI button (iboon-identity docs/ai-assistant.md). The console signs
 * in with a same-origin session cookie and its API checks nothing else, so
 * public/iboon-ai.json says "auth": "cookie" and iBoon AI fetches the API
 * itself. All this adds is context(): the page the person is on, and the
 * device / asset / stock item it shows, as the page already loaded it.
 */

const published: Record<string, unknown> = {};

function publish(key: string, value: unknown): void {
  if (value === null || value === undefined) delete published[key];
  else published[key] = value;
}

/** A detail page names what it shows; it is withdrawn when the page goes. */
export function useIBoonAIContext(key: string, value: unknown): void {
  const json = JSON.stringify(value ?? null);
  useEffect(() => {
    publish(key, value);
    return () => publish(key, null);
    // Keyed on the JSON, not the object's identity: a page rebuilds the object every render.
  }, [key, json]);
}

declare global {
  interface Window {
    iBoonAIApp?: { context?: () => unknown };
  }
}

export function installIBoonAI(): void {
  window.iBoonAIApp = {
    context: () => {
      const page = window.location.pathname;
      const [, section = '', id] = /^\/([^/]+)(?:\/([^/]+))?/.exec(page) ?? [];
      return { page, section, ...(id ? { id } : {}), ...published };
    },
  };
}
